import { Component, Input, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { SortOrder } from '../../types/types'

@Component({
  selector: 'dhp-header',
  templateUrl: './header.component.html',
  imports: [TranslatePipe],
})
export class HeaderComponent {
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() title?: string
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() subtitle?: string
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() sortOrder: SortOrder = 'asc'
  readonly searchPlaceholder = input('')
  readonly showFilter = input(false)
  readonly selectedMagazineIds = input<number[]>([])

  readonly sortOrderChange = output<SortOrder>()
  readonly searchOutput = output<string>()
  readonly magazineSelected = output<number[]>()

  showSortDropdown = false

  onSearch(term: string): void {
    this.searchOutput.emit(term)
  }

  onMagazinesChange(magazineIds: number[]): void {
    this.magazineSelected.emit(magazineIds)
  }

  toggleSortDropdown(): void {
    this.showSortDropdown = !this.showSortDropdown
  }

  setSortOrder(order: SortOrder): void {
    if (this.sortOrder !== order) {
      this.sortOrder = order
      this.sortOrderChange.emit(this.sortOrder)
    }
    this.showSortDropdown = false
  }
}
